export default __webpack_public_path__ + "static/media/front_page_ac.a9f3f91e.png";